class PhoneMask {
  maskedPhone(phoneRaw) {
    this.plus = '';
    if (phoneRaw.match(/^[+]|^[(][+]/)) this.plus = '+';
    const phone = phoneRaw.replace(/(\D)/g, '');
    if (phone.length > 3 && phone.length < 7) {
      const x = phone.match(/(\d{3})/);
      return `(${this.plus}${x[1]}) ${phone.substring(3)}`;
    }
    if (phone.length > 6) {
      const x = phone.match(/(\d{3})(\d{3})/);
      return `(${this.plus}${x[1]}) ${x[2]}-${phone.substring(6)}`;
    }
    return this.plus + phone;
  }
}

export default PhoneMask;



// WEBPACK FOOTER //
// ./src/classes/PhoneMask.js